import cookie from 'js-cookie';
import {
    PROFESSIONAL_URL_PREFIX,
    PROVIDER_URL_PREFIX,
    SIGN_IN_SUCCESS,
    SIGN_IN_LOCKED_USER,
} from './constants';

export const signInSuccess = (
    responseBody,
    isProvider = false,
    suggestedRedirect = null
) => ({
    type: SIGN_IN_SUCCESS,
    responseBody,
    isProvider,
    suggestedRedirect,
});

export const signInUserLocked = (suggestedRedirect = null) => ({
    type: SIGN_IN_LOCKED_USER,
    suggestedRedirect,
});

export function completeMfaSignIn(responseBody) {
    return (dispatch) => {
        cookie.set('entityId', responseBody?.entityId);
        const suggestedRedirect = responseBody?.redirectUrl;
        // These url prefixes are used to match against provider pages that a provider will land on when they sign in.
        // For the complete list:
        // https://github.com/Zocdoc/zocdoc_web/blob/master/ZocDoc.Constants/Provider/Auth/PageFlowControlConstants.cs
        const isProvider =
            suggestedRedirect &&
            (suggestedRedirect.includes(PROFESSIONAL_URL_PREFIX) ||
                suggestedRedirect.includes(PROVIDER_URL_PREFIX));

        return dispatch(
            signInSuccess(responseBody, isProvider, suggestedRedirect)
        );
    };
}

export function setLockedUserRedirect(responseBody) {
    return (dispatch) => {
        const suggestedRedirect = responseBody?.redirectUrl;
        return dispatch(signInUserLocked(suggestedRedirect));
    };
}
